export const OSSA_BASE_URL = process.env.REACT_APP_OSSA_BASE_URL;
